import { takeLatest, put, call } from 'redux-saga/effects';
import { Reward, RewardsAction, RewardsTypes } from '../types';
import { getListRewards, saveReward } from '../actions';
import { getRewardsFirebase, saveRewardFirebase } from '../repository';

export function* requestGetListRewardsSaga(): unknown {
    try {
        const rewards = yield call(getRewardsFirebase);
        yield put(getListRewards(rewards));
    } catch (err: unknown) {
        yield put(getListRewards([]));
    }
}

export function* requestSaveRewardSaga(props: RewardsAction<{ reward: Reward }>): unknown {
    try {
        const reward = yield call(saveRewardFirebase, props.payload.reward);
        yield put(saveReward(reward));
    } catch (err: unknown) {
        yield put(saveReward());
    }
}

export default [
    takeLatest(RewardsTypes.REQUEST_GET_LIST_REWARDS, requestGetListRewardsSaga),
    takeLatest(RewardsTypes.REQUEST_SAVE_REWARD, requestSaveRewardSaga),
];
